import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBooleanGroupUnion"><Path d="M8 2V8H2V22H16V16H22V2H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
